import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Briefcase, ArrowLeft, Search, AlertTriangle } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import ApplicationStatusManager from '../components/applications/ApplicationStatusManager';

const MyApplicationsPage = () => {
    const { user } = useAuth();
    const navigate = useNavigate();

    return (
        <div className="my-applications-page">
            <Container fluid className="px-4">
                <Row className="mb-4">
                    <Col>
                        <div className="page-header d-flex justify-content-between align-items-center">
                            <div>
                                <h2 className="page-title mb-1 d-flex align-items-center">
                                    <Briefcase size={24} className="me-2 text-primary" />
                                    My Job Applications
                                </h2>
                                <p className="page-subtitle text-muted mb-0">
                                    Track the status of your job applications and view updates from recruiters
                                </p>
                            </div>
                            <div className="page-actions d-flex">
                                <Button 
                                    variant="outline-secondary" 
                                    className="me-2 d-flex align-items-center"
                                    onClick={() => navigate('/dashboard')}
                                >
                                    <ArrowLeft size={18} className="me-2" />
                                    Back to Dashboard
                                </Button>
                                <Button 
                                    variant="primary"
                                    className="d-flex align-items-center"
                                    onClick={() => navigate('/')}
                                >
                                    <Search size={18} className="me-2" />
                                    Find Jobs
                                </Button>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        {user ? (
                            <ApplicationStatusManager 
                                userType={user.userType} 
                                userId={user.userId} 
                            />
                        ) : (
                            <Card className="border-0 shadow-sm">
                                <Card.Body className="text-center py-5">
                                    <AlertTriangle size={48} className="text-warning mb-3" />
                                    <h4>Authentication Required</h4>
                                    <p className="text-muted">Please log in to view your applications.</p>
                                    <Button variant="primary" onClick={() => navigate('/login')}>
                                        Go to Login
                                    </Button>
                                </Card.Body>
                            </Card>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default MyApplicationsPage;